import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DashboardButtonService {
    private redirectToNewNotificationListSubject = new BehaviorSubject<boolean>(false);
    public onRedirectToDashboard$ = this.redirectToNewNotificationListSubject.asObservable();

    public redirectToNewNotificationList(value: boolean): void {
        this.redirectToNewNotificationListSubject.next(value);
    }
}
